fx.ns("desktop.common.panels", class SharedPhotosPanel extends fx.Component {
	constructor() 
	{
		super();
		this._currentSharedPhotos = fx.service("PhotoSharingService").currentSharedPhotos.photos;
		this._selectedPhotosNumber = 0;
      	this.destroyOnSwitch = true;
	}

	create() {
		super.create();


		this.container = new fx.components.HBox("container");
		this.layoutsGrid = new fx.components.VerticalGridDynamic( { className : "layoutGrid",
			data : this._currentSharedPhotos,
			maxRowHeight : 130,
			newChildEffect : "fade",
			renderers : {Photo : shared.renderers.SharedPhotoSelectRenderer} 
		} );
		this.addChild(this.layoutsGrid, {width:"85%", top : 170, left: "center"});
		this._unselectAll();

		this._updateSelectedPhotosNumber();

		// title
		this.title = new fx.components.Text({ text: fx.text("Sélectionnez les photos que vous souhaitez garder"), className: "title bold center" });
		this.addChild(this.title, { width: "100%", left: "center", top: 60 });
		
		// "select all" link
		this.selectAllLink = new fx.components.Text({ text: fx.text("Tout sélectionner ($)", this._currentSharedPhotos.length), className: "selectAllLink" });
		this.addChild(this.selectAllLink, { right: "7%", top: 130 });

		this.buttonHBox = new fx.components.HBox();

		this.exitBtn = new fx.components.Button({label:fx.text("Quitter"), className : "exitBtn"});
		this.buttonHBox.addChild(this.exitBtn, {width: 170});

		this.validateBtn = new fx.components.Button({label:fx.text("Valider ($)", this._selectedPhotosNumber), className : "validateBtn"});
		this.buttonHBox.addChild(this.validateBtn, {width: 170});

		this.addChild(this.buttonHBox, {left: "center", bottom: 35});

		this.previewImage = new fx.components.Image({className : "preview"} );
		this.addChild(this.previewImage, { height : 350, width: 450});
		this.previewImage.visibleAtStart = false;

		this._updateLabels();
	}

	onReady() {
		super.onReady();

		// events
		this.on("click", this._onValidate, this.validateBtn);
		this.on("click", this._onClose, this.exitBtn);
		this.on("click", this._onToggleSelectAll, this.selectAllLink);

		this.on("mouseover", this._onMouseOver, this.layoutsGrid);
		this.on("mouseout", this._onMouseOut, this.layoutsGrid);

		this.on("selected", this._onSelected, this.layoutsGrid);

		this.listenUpdates(this.data.creation, true);
	}

    destroy()
    {
        super.destroy();
        this.listenUpdates(this.data.creation, false);
    }

	// Events

	_onMouseOut(e)
	{
		if(this.previewImage)
		{
			this.previewImage.hide();
			this.delay(this._showPreview, null);
		}
	}

	_onMouseOver(e)
	{
		if(e.target instanceof HTMLImageElement)
		{
			let element = fx.dom.parent(e.target, ".SharedPhotoSelectRenderer");
			let url = this.layoutsGrid.getChildFromUI(element).data.url;
			if(element)
			{
				this.previewImage.data = url;
				let zoomedWidth = fx.dom.width(element)*2;
				let zoomedHeight = fx.dom.height(element)*2;
				let posX = e.x;
				let posY = e.y-fx.dom.height(element);
				if ( (posX+zoomedWidth) > fx.graphics.screenSize().width)
					posX = e.x-zoomedWidth;
				if ( (posY+zoomedHeight) > fx.graphics.screenSize().height )
					posY = e.y-zoomedHeight;
				this.previewImage.viewport({height : zoomedHeight, width: zoomedWidth, top: posY, left: posX});
			}
			this.delay(this._showPreview, 1000);
		}
	}

	_showPreview(){
		this.previewImage.show();
	}

	_onSelected()
    {
		this._updateSelectedPhotosNumber();
		this._updateLabels();
	}

	_updateSelectedPhotosNumber()
	{
		let cpt = 0;
		for(var i = 0; i < this.layoutsGrid.data.length; i++)
		{
			if(this.layoutsGrid.data.getItemAt(i).selected)
				cpt++;
		}
		this._selectedPhotosNumber = cpt;
	}

	_updateLabels()
	{
		this.validateBtn.label = fx.text("Valider ($)", this._selectedPhotosNumber);
		this._selectedPhotosNumber<=0 ? this.validateBtn.disabled = true : this.validateBtn.disabled = false;
		let isSelected = this.selectAllLink.hasClass("selected");
		if(!isSelected)
			this.selectAllLink.text = fx.text("Tout sélectionner ($)", this._currentSharedPhotos.length);
		else
			this.selectAllLink.text = fx.text("Tout déselectionner ($)", this._selectedPhotosNumber);
	}

	_onToggleSelectAll(){
		this.selectAllLink.toggleClass("selected");
		let isSelected = this.selectAllLink.hasClass("selected");
		for(var i = 0; i < this.layoutsGrid.data.length; i++){
			this.layoutsGrid.data.getItemAt(i).selected = isSelected;
		}
		this._updateSelectedPhotosNumber();
		this._updateLabels();
	}

	_unselectAll(){
		for(var i = 0; i < this.layoutsGrid.data.length; i++){
			this.layoutsGrid.data.getItemAt(i).selected = false;
		}
	}

	_onValidate(event) {
		this.data.event("show-editor");
		fx.service("PhotoSharingService").validate();
	}

	_onClose()
	{
		this.popup(new shared.popups.SharedPhotosRefusePopup(this.data));
	}

});
